import { render, staticRenderFns } from "./ApprovalImageProfileReject.vue?vue&type=template&id=0cb8199d&"
import script from "./ApprovalImageProfileReject.vue?vue&type=script&lang=js&"
export * from "./ApprovalImageProfileReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports